import classNames from "classnames";
import React from "react";
import Tooltip from "./../../../wix-rich-content-common/lib/Tooltip.js";
import styles from "./list-item-select-scss.js";
const ListItemSelect = ({
  title,
  subtitle,
  prefix,
  suffix,
  dataHook,
  selected,
  disabled,
  onClick,
  tooltip,
  onKeyDown,
  className
}) => {
  return /* @__PURE__ */ React.createElement(Tooltip, { content: tooltip }, /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classNames(styles.container, className, {
        [styles.selected]: selected
      }),
      tabIndex: 0,
      onKeyDown,
      "data-hook": dataHook,
      "data-selected": selected,
      onClick: disabled ? void 0 : onClick
    },
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classNames(styles.content, {
          [styles.content_mobile_alignCenter]: !title
        })
      },
      prefix && /* @__PURE__ */ React.createElement("div", { className: styles.prefix }, prefix),
      title && /* @__PURE__ */ React.createElement("div", { className: styles.titleWrapper }, title && /* @__PURE__ */ React.createElement("div", { className: styles.title }, title), subtitle && /* @__PURE__ */ React.createElement("div", { className: styles.subtitle }, subtitle)),
      suffix && /* @__PURE__ */ React.createElement("div", { className: styles.suffix }, suffix)
    )
  ));
};
var ListItemSelect_default = ListItemSelect;
export {
  ListItemSelect_default as default
};
//# sourceMappingURL=ListItemSelect.js.map
